<template>
  <tabs>
    <tab name="Details" :selected="true">
      <div class="mx-auto p-2 md:p-6 bg-white">
        <div class="flex flex-col md:flex-row md:justify-between space-y-4 md:space-y-0">
          <div class="md:border-r md:pr-4 md:mr-4">
            <form-generator :form_schema="showSeriesDetailsSchema" :show_label="true" :isAdmin="true" ref="series_form"/>
            <button class="btn btn-blue" @click="saveShowDetails">Save Details</button>
          </div>
          <div class="md:w-128">
            <div class="mb-4">
              <div class="flex items-center justify-between w-full pb-2 border-b mb-2">
                <p class="text-2xl font-light">Logo</p>
                <button id="upload_widget" @click="openUploadModal" class="btn-xs btn-blue cloudinary-button">Upload Logo</button>
              </div>
              <img :src="seriesLogoURL" class="h-48 w-48 rounded-lg"/>
            </div>
            <form-generator :form_schema="showSeriesFiles" :show_label="true" :isAdmin="true" ref="series_files_form"/>
            <button class="btn btn-blue" @click="saveShowDetails">Save</button>
          </div>
        </div>
      </div>
    </tab>
    <tab name="Settings">
      <div class="mx-auto p-2 md:p-8 bg-white">
        <div class="flex flex-col md:flex-row md:justify-between space-y-4 md:space-y-0">
          <div class="md:w-128 md:border-r md:pr-4 md:mr-4">
            <form-generator :form_schema="basicShowSeriesSettingsSchema" :show_label="true" :isAdmin="true" ref="series_form_basic_settings"/>
            <button class="btn btn-blue" @click="saveShowSettings">Save Setting</button>
          </div>
          <div class="w-full">
            Advanced
          </div>
        </div>
      </div>
    </tab>
    <tab name="Advanced">
      <div class="mx-auto max-w-3xl">
        <h1>Advanced Settings</h1>
        <!--<button @click="reRunAllPoints">Rerun all series points</button>-->
        <div class="my-6">
          <label class="text-2xl mb-1">Assigned Show Specialist</label>
          <v-select @input="specialistChanged" :options="specialists" :reduce="option => option.value" label="label" v-model="showSeries.series_settings.show_specialist_id"/>
        </div>
        <div class="my-6">
          <label class="text-2xl mb-1">Series Templates</label>
          <div class="flex items-center w-full p-2 bg-gray-200 space-x-2">
            <showman-type-ahead v-model="templateToAdd" class="w-full" :placeholder="'Start typing to find a template to add'" :label="'identifier'" :dataEndpoint="'/callFunction/templateSearch'" :schema="templateTypeAheadSchema" :internalSearch="false"></showman-type-ahead>
            <button class="btn-xs btn-green" @click="addSeriesTemplate">Add</button>
          </div>
          <div>
            <div v-for="(st, i) in showSeries.series_templates" :key="i" class="flex justify-between items-center py-1.5 border-t">
              <p>{{ st.show_template_identifier}}</p>
              <button class="btn-xs btn-red" @click="removeSeriesTemplate(st, i)">X</button>
            </div>
          </div>
        </div>
        <div class="my-6">
          <label class="text-2xl mb-1">Series Shows</label>
          <div class="flex items-center w-full p-2 bg-gray-200 space-x-2">
            <showman-type-ahead v-model="eventToAdd" class="w-full" :initialValue="eventToAdd"  :placeholder="'Start typing to find an event to add'" :label="'Animal'" :dataEndpoint="'/callFunction/eventSearch'" :schema="eventTypeAheadSchema" :internalSearch="false"></showman-type-ahead>
            <button class="btn-xs btn-green" @click="addSeriesEvent">Add</button>
          </div>
          <div>
            <div v-for="(e, i) in showSeries.series_events" :key="i" class="flex justify-between items-center py-1.5 border-t">
              <p>{{ e.start_date }} ~ {{ e.name }}</p>
              <div class="flex items-center space-x-2">
                <button class="btn-link" @click="runSeriesPoints(e.event_id, e.name)">Run Points</button>
                <button class="btn-xs btn-red" @click="removeSeriesEvent(e, i)">X</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
  </tabs>
</template>

<script>
import ShowmanTypeAhead from '@/components/ShowmanTypeAhead.vue'

export default {
  components: {
    ShowmanTypeAhead
  },
  data () {
    return {
      specialists: [
        {
          label: 'Brandy',
          value: '9tWzGNjoUZWFjonz2PJJpAnkGxg1'
        },
        {
          label: 'Layne',
          value: '2S1n15f3I0OJjgpLx5pMlHdAfT13'
        },
        {
          label: 'Olivia',
          value: 'AmtbH8WVMsOneNemxsGcShyc9IE2'
        },
        {
          label: 'Susan',
          value: 'WK7NrDb812UPUK2x7VZynNArOIo2'
        },
        {
          label: 'Ruth',
          value: 'RMv8Utnqrfg3UiVwSazoLs8lFE43'
        }
      ],
      eventToAdd: null,
      eventTypeAheadSchema: {
        idField: 'event_id',
        searchField1: 'name',
        serachField2: 'start_date',
        displayTemplate: '$1 ~ $2 ($3)',
        displayFields: ['start_date', 'name', 'state']
      },
      templateToAdd: null,
      templateTypeAheadSchema: {
        idField: 'show_template_id',
        searchField1: 'show_template_identifier',
        displayTemplate: '$1',
        displayFields: ['show_template_identifier']
      },
      showSeriesSettings: {},
      showSeriesDetails: {},
      baseMembershipTypeSchema: [
        {
          label: 'Membership Type',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              model: 'membership_type',
              label: 'Membership Type/Label'
            },
            {
              type: 'input',
              inputType: 'number',
              model: 'membership_cost',
              label: 'Membership Cost'
            }
          ]
        }
      ]
    }
  },
  computed: {
    showSeries () {
      return this.$store.state.showSeries_.currentShowSeries
    },
    seriesLogoURL () {
      return this.showSeries.series_details ? `https://res.cloudinary.com/showman/image/upload/c_scale,h_300/${this.showSeries.series_details.logo_id}` : '#'
    },
    showSeriesFiles () {
      return [
        {
          label: 'Files',
          model: this.showSeriesDetails,
          fields: [
            {
              model: 'show_rules',
              label: 'Show Rules',
              type: 'file'
            },
            {
              model: 'series_flyer',
              label: 'Series Flyer',
              type: 'file'
            }
          ]
        }
      ]
    },
    showSeriesDetailsSchema () {
      return [
        {
          label: 'Series Details',
          model: this.showSeriesDetails,
          fields: [
            {
              model: 'year',
              label: 'Series Year',
              type: 'input',
              inputType: 'number'
            },
            {
              model: 'species',
              label: 'Species',
              type: 'input',
              inputType: 'text',
              hint: 'Enter comma seperated text'
            },
            {
              model: 'website',
              label: 'Website',
              type: 'input',
              inputType: 'text',
              hint: 'Use the full url'
            },
            {
              model: 'contact_name',
              label: 'Contact Name',
              type: 'input',
              inputType: 'text'
            },
            {
              model: 'contact_email',
              label: 'contact Email',
              type: 'input',
              inputType: 'text'
            },
            {
              model: 'contact_phone',
              label: 'Contact Phone',
              type: 'input',
              inputType: 'text'
            },
            {
              model: 'facebook_page',
              label: 'Facebook Page',
              type: 'input',
              inputType: 'text',
              hint: 'Use the full url'
            }
          ]
        }
      ]
    },
    basicShowSeriesSettingsSchema () {
      return [
        {
          label: 'Series Standings',
          model: this.showSeriesSettings,
          fields: [
            {
              model: 'hide_standings',
              label: 'Hide Series Standings?',
              type: 'checkbox',
              hint: 'If check standings will be hidden. You can still access directly when signed into admin account.'
            }
          ]
        },
        {
          label: 'Membership Settings',
          model: this.showSeriesSettings,
          fields: [
            {
              model: 'online_membership',
              label: 'Online Membership',
              type: 'checkbox',
              hint: 'Check if online membership is available'
            },
            {
              model: 'species_specific',
              label: 'Species Specific Membership',
              type: 'checkbox',
              hint: 'Check if membership is species specific.'
            },
            {
              model: 'modified_form',
              label: 'Use Custom Membership form',
              type: 'checkbox',
              hint: 'Check if series needs custom membership form. Address info is always asked'
            }
          ]
        },
        {
          label: 'Financial Settings',
          model: this.showSeriesSettings,
          fields: [
            {
              model: 'pass_on_fees',
              label: 'Pass on CC Fees?',
              type: 'checkbox',
              hint: 'Check if fees should be passed on.'
            },
            {
              model: 'cc_percent_fee',
              label: 'What is the CC fee that is charged?',
              type: 'input',
              inputType: 'number',
              hint: 'CC Fee %, 3.5% is the standard'
            },
            {
              model: 'series_fee',
              label: 'How much series fee should be held back from membership dues?',
              type: 'input',
              inputType: 'number',
              hint: 'How much of a series fee will be witheld from membership fees.'
            }
          ]
        }
      ]
    }
  },
  methods: {
    specialistChanged () {
      this.$store.state.apiInstance.post(`/callFunction/updateSeriesSettings`, {
        updateData: JSON.stringify({
          show_series_id: this.showSeries.show_series_id,
          field: 'show_specialist_id',
          value: this.showSeries.series_settings.show_specialist_id,
          type: 'text'
        })
      })
        .then(() => {
          this.notie.alert({type: 'success', text: 'Series specialist updated'})
        })
        .catch(() => {
          alert('Error Updating Series specialist Settings')
        })
    },
    removeSeriesEvent (event, index) {
      this.$store.state.apiInstance.delete(`/data/admin/seriesEvents/${event.id}`)
        .then(() => {
          this.showSeries.series_events.splice(index, 1)
          this.notie.alert({type: 'success', text: 'Event removed from series'})
        })
        .catch(err => {
          this.notie.alert({type: 'error', text: err.message})
        })
    },
    addSeriesEvent () {
      this.$store.state.apiInstance.post(`/data/seriesEvents`, {
        show_series_id: this.showSeries.show_series_id,
        event_id: this.eventToAdd.event_id
      })
        .then((response) => {
          this.eventToAdd.id = response.data.data.id
          this.showSeries.series_events.push(this.eventToAdd)
          this.eventToAdd = null
          this.notie.alert({type: 'success', text: 'Event added to series'})
        })
        .catch(err => {
          this.notie.alert({type: 'error', text: err.message})
        })
    },
    addSeriesTemplate () {
      this.$store.state.apiInstance.post('/data/showSeriesTemplates', {
        show_series_id: this.showSeries.show_series_id,
        show_template_id: this.templateToAdd.show_template_id
      })
        .then((response) => {
          this.showSeries.series_templates.push({
            id: response.data.data.id,
            show_template_identifier: this.templateToAdd.show_template_identifier
          })
          this.templateToAdd = null
          this.notie.alert({type: 'success', text: 'Template added to series'})
        })
        .catch(err => {
          this.notie.alert({type: 'error', text: err.message})
        })
    },
    removeSeriesTemplate (template, index) {
      this.$store.state.apiInstance.delete(`/data/admin/showSeriesTemplates/${template.id}`)
        .then(() => {
          this.showSeries.series_templates.splice(index, 1)
          this.notie.alert({type: 'success', text: 'Template removed from series'})
        })
        .catch(err => {
          this.notie.alert({type: 'error', text: err.message})
        })
    },
    runSeriesPoints (eventID, name) {
      this.$store.state.apiInstance.get(`/points?event_id=${eventID}`)
        .then(() => {
          this.notie.alert({type: 'success', text: `Points updated for ${name}`})
        })
    },
    reRunAllPoints () {
      this.showSeries.events.forEach(e => {
        this.runSeriesPoints(e.event_id, e.name)
      })
    },
    saveShowDetails () {
      this.$store.state.apiInstance.put(`/data/showSeries/${this.showSeries.show_series_id}`, {
        series_details: this.showSeriesDetails
      })
        .then(() => {
          this.notie.alert({type: 'success', text: 'Series Details updated'})
        })
        .catch(() => {
          alert('Error Updating Series Details')
        })
    },
    saveShowSettings () {
      this.$store.state.apiInstance.put(`/data/showSeries/${this.showSeries.show_series_id}`, {
        series_settings: this.showSeriesSettings
      })
        .then(() => {
          this.notie.alert({type: 'success', text: 'Series settings updated'})
        })
        .catch(() => {
          alert('Error Updating Series Settings')
        })
    },
    openUploadModal () {
      window.cloudinary.openUploadWidget(
        {
          cloud_name: 'showman',
          upload_preset: 'lmojbfbq'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.setSeriesLogo(result.info.path)
          }
        }).open()
    },
    setSeriesLogo (path) {
      this.showSeriesDetails.logo_id = path
      this.saveShowDetails()
      /* this.$store.state.apiInstance.post(`/callFunction/updateEventDetail`, {
        updateData: JSON.stringify({
          event_id: this.coverPhotoEvent.event_id,
          field: 'home_cover_url',
          value: HOME_COVER_BASE + path,
          type: 'text'
        })
      })
        .then(() => {
          Vue.set(this.coverPhotoEvent, 'cover_photo', HOME_COVER_BASE + path)
        })
        .catch(() => {
          alert('Error Updating home_cover_url')
        })

      this.$store.state.apiInstance.post(`/callFunction/updateEventDetail`, {
        updateData: JSON.stringify({
          event_id: this.coverPhotoEvent.event_id,
          field: 'event_card_cover_url',
          value: EVENT_COVER_BASE + path,
          type: 'text'
        })
      })
        .catch(() => {
          alert('Error Updating event_card_cover_url')
        }) */
    }
  },
  mounted () {
    this.showSeriesSettings = this.showSeries.series_settings
    this.showSeriesDetails = this.showSeries.series_details
  }
}
</script>

<style>

</style>
